let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ahxSD"), load("7FkEF"), load("9IRbx")]).then(() => parcelRequire('fuCaZ'));